import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Select, Button, message } from "antd";
import API from "../../api";

const { Option } = Select;

const UserForm = ({ open, setOpen, selectedUser, onEdit }) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const [stores, setStores] = useState([]);
  const [isFetchingStores, setFetchingStores] = useState(true);
  const [isStoreFieldRequired, setStoreFieldRequired] = useState(false);
  const [roles, setRoles] = useState(null);

  // Fetch stores from the API
  const getStores = async () => {
    try {
      setFetchingStores(true);
      const response = await API.get("/stores");
      setStores(response.data);
    } catch (err) {
      console.error("Error fetching stores:", err);
      message.error("Failed to fetch stores.");
    } finally {
      setFetchingStores(false);
    }
  };

  const getRoles = async () => {
    try {

      const response = await API.get("/roles");
      setRoles(response?.data?.roles)

    } catch (error) {
      console.error("Error fetching stores:", error);
      message.error("Failed to fetch stores.");

    }
  }

  useEffect(() => {
    getRoles();
    getStores();
    if (selectedUser) {
      form.setFieldsValue({
        ...selectedUser,
        storeId: selectedUser.storeId?._id ? selectedUser.storeId?._id : null,
        role: selectedUser.role?._id || null,
      });

      // Set `storeId` requirement based on the user's role
      if (selectedUser?.role?.name === "manager" || selectedUser?.role?.name === "staff") {
        setStoreFieldRequired(true);
      }
    } else {
      form.resetFields();
      setStoreFieldRequired(false);
    }
  }, [selectedUser]);

  const onValuesChange = (changedValues, allValues) => {
    if (changedValues.role) {
      // const role = changedValues.role;
      const roleObj = roles.find(role => role._id === changedValues.role);
      // Get the role name (e.g., "staff") or undefined if not found
      const roleName = roleObj ? roleObj.name : null;
      console.log(changedValues)
      setStoreFieldRequired(roleName === "manager" || roleName === "staff");

      if (roleName !== "manager" && roleName !== "staff") {
        form.setFieldsValue({ storeId: undefined });
      }
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      let response;
      if (selectedUser) {
        response = await API.put(`/users/${selectedUser._id}`, values);
      } else {
        response = await API.post("/users", values);
      }
      message.success("User saved successfully!");
      onEdit(response.data);
      form.resetFields();
      setOpen(false);
    } catch (err) {
      console.error("Error saving user:", err);
      message.error(err.response?.data?.message || "Failed to save user.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title={selectedUser ? "Edit User" : "Add User"}
      width={500}
      placement="right"
      onClose={() => setOpen(false)}
      open={open}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onValuesChange={onValuesChange}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please enter the user's name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Please enter the user's email!" },
            { type: "email", message: "Please enter a valid email!" },
          ]}
        >
          <Input disabled={!!selectedUser} />
        </Form.Item>

        {!selectedUser ? <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please enter the password!" }]}
        >
          <Input.Password />
        </Form.Item>
          : null}
        <Form.Item
          label="Role"
          name="role"
          rules={[{ required: true, message: "Please select a role!" }]}
        >
          <Select
            placeholder="Select Role"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => {
              if (option?.children) {
                const searchValue = input.toLowerCase();
                const text = option.children.toLowerCase();
                return text.includes(searchValue);
              }
              return false;
            }}
          >
            {roles?.map((role) => (
              <Option key={role?._id} value={role?._id}>
                {role?.name}
              </Option>
            ))}
          </Select>
        </Form.Item>


        {isStoreFieldRequired && (
          <Form.Item
            label="Store"
            name="storeId"
            rules={[{ required: true, message: "Please select a store!" }]}
          >
            <Select
              placeholder="Select Store"
              loading={isFetchingStores}
              notFoundContent={isFetchingStores ? "Loading stores..." : "No stores available"}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                if (option?.props?.children) {
                  const searchValue = input.toLowerCase();
                  const text = option.props.children.toLowerCase();
                  return text.includes(searchValue);
                }
                return false;
              }}
            >
              {stores.map((store) => (
                <Option key={store._id} value={store._id}>
                  {store.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}


        <Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading} block>
            Save
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default UserForm;
